export default __webpack_public_path__ + "static/media/googleLogo.66ae25be.svg";